<template>
  <button
    class="relative flex items-center font-bold text-base"
    data-testid="goBackButton"
    @click="$emit('goBack')"
  >
    <span
      class="mr-2 iconify svg--chevron-left font-bold"
    />
    <span class="text-base font-bold text-EXPONDO-black">{{ backButtonText }}</span>
  </button>
</template>

<script lang="ts">

export default defineComponent({
  name: 'GoBack',
  props: {
    backButtonText: {
      type: String,
      required: true,
    },
  },
  emits: ['goBack'],
});

</script>
